export function changeLocationPathName(pathName){
    if(pathName==undefined)
      return;
    window.history.pushState({},'',window.location.origin+pathName);
    let event=new Event('onurlupdate');
    window.dispatchEvent(event);
}